import { render } from "./SettingSideBar.vue?vue&type=template&id=12e09ae4&scoped=true"
import script from "./SettingSideBar.vue?vue&type=script&lang=js"
export * from "./SettingSideBar.vue?vue&type=script&lang=js"

import "./SettingSideBar.vue?vue&type=style&index=0&id=12e09ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e09ae4"]])

export default __exports__